import { Redirect, Route } from 'react-router-dom';
import {
  IonApp,
  IonIcon,
  IonLabel,
  IonRouterOutlet,
  IonTabBar,
  IonTabButton,
  IonTabs,
  setupIonicReact
} from '@ionic/react';
import { IonReactRouter } from '@ionic/react-router';

import Impostazioni from './pages/Impostazioni';
import Ordini from './pages/Ordini';
import DefinizioneImpianto from './pages/DefinizioneImpianto';
import Preset from './pages/Preset';
import Menu from './pages/Menu';
import Impianto from './pages/Impianto';
import Forno from './pages/Forno';
/* Core CSS required for Ionic components to work properly */
import '@ionic/react/css/core.css';

/* Basic CSS for apps built with Ionic */
import '@ionic/react/css/normalize.css';
import '@ionic/react/css/structure.css';
import '@ionic/react/css/typography.css';

/* Optional CSS utils that can be commented out */
import '@ionic/react/css/padding.css';
import '@ionic/react/css/float-elements.css';
import '@ionic/react/css/text-alignment.css';
import '@ionic/react/css/text-transformation.css';
import '@ionic/react/css/flex-utils.css';
import '@ionic/react/css/display.css';

/* Theme variables */
import './theme/variables.css';



/*icons */
import {pizza} from 'ionicons/icons';
import { settings } from 'ionicons/icons';
import { fileTrayStacked } from 'ionicons/icons';
import { flame } from 'ionicons/icons';


setupIonicReact();

const App: React.FC = () => (
  <IonApp>
    <IonReactRouter>
      
      <IonTabs>
        <IonRouterOutlet>
          <Route exact path="/Menu">
            <Menu />
          </Route>
          <Route path="/Impostazioni">
            <Impostazioni />
          </Route>
          <Route exact path="/">
            <Redirect to="/Menu" />
          </Route>
          <Route exact path="/DefinizioneImpianto">
            <DefinizioneImpianto />
          </Route>  
          <Route exact path="/Ordini">
            <Ordini />
          </Route>  
          <Route exact path="/Preset">
            <Preset />
            </Route>  
            <Route exact path="/Impianto">
            <Impianto />
            </Route>  
            <Route exact path="/Forno">
            <Forno />
            </Route>  

          





        </IonRouterOutlet>
        
        <IonTabBar class={'tabBar'} slot="bottom">
          <IonTabButton class={'hovertab'}tab="Ordini" href="/Ordini" >
         <IonIcon icon={pizza} style={{color: "white"}}/>
            <IonLabel style={{fontSize:"17px",paddingTop:"3px", color: "white"}}>Ordini</IonLabel>
          </IonTabButton>
          <IonTabButton class={'hovertab'}tab="Forno" href="/Forno">
            <IonIcon icon={flame} style={{color: "white"}}/>
            <IonLabel style={{fontSize:"17px",paddingTop:"3px", color: "white"}}>Forno</IonLabel>
          </IonTabButton>
          <IonTabButton class={'hovertab'}tab="Impianto" href="/Impianto">
            <IonIcon icon={fileTrayStacked} style={{color: "white"}}/>
            <IonLabel style={{fontSize:"17px",paddingTop:"3px", color: "white"}}>Impianto</IonLabel>
          </IonTabButton>
          <IonTabButton class={'hovertab'}tab="Impostazioni" href="/Impostazioni">
            <IonIcon icon={settings} style={{color: "white"}}/>
            <IonLabel style={{fontSize:"17px",paddingTop:"3px", color: "white"}}>Impostazioni</IonLabel>
          </IonTabButton>
      

     


        </IonTabBar>
      
      </IonTabs>
    </IonReactRouter>
  </IonApp>
);

export default App;
